import React from 'react'
import PropTypes from 'prop-types'
import Loginform from 'components/loginform'
import 'assets/sass/main.scss';
function boardingscreen(props) {
    return (
        <div className="login-main">
             <Loginform/>
        </div>
    )
}

boardingscreen.propTypes = {

}

export default boardingscreen

